export const getFirstDayPrevMonth = (date: any) => {
  const currentDate = new Date(date);
  const firstDayPrevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
  return firstDayPrevMonth;
};
